import axios, {
  AxiosError,
} from 'axios';
import {
  createPinia,
} from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import {
  createApp,
} from 'vue';
import {
  registerStore,
  resetStore,
  useStore,
} from './store';
import App from '@/App.vue';
import {
  ROUTE_API,
  baseUrl,
} from '@/helpers';
import router from '@/router';
import '@/style/css/index.css';
import '@/style/scss/index.scss';

const app = createApp(App);
const pinia = createPinia();

pinia.use(piniaPluginPersistedstate);
app.use(pinia);

app.config.errorHandler = (err, vm, info): void => {
  console.error(`Error in ${info}:`, err);

  const authStore = useStore.auth;

  const username = authStore.user?.username || 'NA';

  const data = {
    message: `[${username}] ${(err as Error).message}`,
    info,
    stack: (err as Error).stack,
  };
  axios.post('/errors', data)
    .catch(console.error);
};

axios.defaults.baseURL = `${baseUrl}${ROUTE_API}`;

axios.interceptors.response.use(undefined, async (error) => {
  const errResponse = (error as AxiosError).response;
  const authStore = useStore.auth;

  if (errResponse?.status === 401 && errResponse?.data === 'Unauthorized') {
    authStore.logout();
    if (router.currentRoute.value.fullPath !== '/') {
      await router.push('/');
    }
  }

  return Promise.reject(error);
});

app.use(router);

resetStore();
registerStore();

app.mount('#app');
